var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PCH5\u5931\u8D25") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-520.000000, -465.000000)",
    fill: "#E04F33",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-circle-fill",
    transform: "translate(520.000000, 465.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,3 C12.403125,3 3,12.403125 3,24 C3,35.596875 12.403125,45 24,45 C35.596875,45 45,35.596875 45,24 C45,12.403125 35.596875,3 24,3 Z M31.753125,31.978125 L28.659375,31.9640625 L24,26.409375 L19.3453125,31.959375 L16.246875,31.9734375 C16.040625,31.9734375 15.871875,31.809375 15.871875,31.5984375 C15.871875,31.509375 15.9046875,31.425 15.9609375,31.3546875 L22.059375,24.0890625 L15.9609375,16.828125 C15.9046875,16.7578125 15.871875,16.6734375 15.871875,16.584375 C15.871875,16.378125 16.040625,16.209375 16.246875,16.209375 L19.3453125,16.2234375 L24,21.778125 L28.6546875,16.228125 L31.7484375,16.2140625 C31.9546875,16.2140625 32.1234375,16.378125 32.1234375,16.5890625 C32.1234375,16.678125 32.090625,16.7625 32.034375,16.8328125 L25.9453125,24.09375 L32.0390625,31.359375 C32.0953125,31.4296875 32.128125,31.5140625 32.128125,31.603125 C32.128125,31.809375 31.959375,31.978125 31.753125,31.978125 Z",
    id: "\\u5F62\\u72B6"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a184ca496fdb2a6c008477024441ba55.svg";
export { ForwardRef as ReactComponent };